module.exports = __webpack_public_path__ + "img/goenroll123-mobile-view-logo.d399931d.png";